import { Link } from "react-router-dom";
import { useClub } from "@/hooks/useClub";

export default function Footer() {
  const { club: data } = useClub();

  const tel = data?.tel || "042-000-0000";
  const email = data?.email || "";
  const addr = data?.addr || "대전광역시 중구";
  const bank = data?.bank;

  return (
    <footer className="mt-16 w-full bg-accent-500 text-primary-950">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="flex-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-950 text-accent-400">
                <i className="ri-seedling-fill text-lg" aria-hidden="true"></i>
              </span>
              <div className="flex flex-col leading-tight">
                <span className="font-heading font-bold text-[16px]">
                  {data?.club_name || "대전민들레로타리클럽"}
                </span>
                <span className="text-xs opacity-80">
                  {data?.district || "국제로타리 3680지구"}
                </span>
              </div>
            </div>
            <p className="text-sm opacity-90 max-w-md leading-relaxed">
              봉사의 씨앗을 멀리 퍼뜨리는 대전의 로타리클럽. 지역사회와 함께 성장하고
              회원 간 비즈니스를 연결합니다.
            </p>

            {bank && (bank.name || bank.account) && (
              <div className="mt-5 inline-flex flex-col rounded-lg bg-primary-950/10 px-4 py-3 text-sm">
                <span className="text-xs opacity-80">클럽 계좌</span>
                <span className="font-semibold">
                  {[bank.name, bank.account].filter(Boolean).join(" ")}
                </span>
                {bank.holder && <span className="text-xs opacity-80">예금주 {bank.holder}</span>}
              </div>
            )}
          </div>

          <div className="grid grid-cols-2 gap-8 text-sm">
            <div>
              <h4 className="font-heading font-semibold mb-3">둘러보기</h4>
              <ul className="space-y-2">
                <li><Link to="/about" className="hover:underline">클럽소개</Link></li>
                <li><Link to="/cards" className="hover:underline">명함</Link></li>
                <li><Link to="/bizmap" className="hover:underline">민들레 비즈맵</Link></li>
                <li><Link to="/notices" className="hover:underline">공지사항</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading font-semibold mb-3">연락처</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line mt-0.5" aria-hidden="true"></i>
                  <a href={`tel:${tel.replace(/[^0-9+]/g, "")}`} className="hover:underline">
                    {tel}
                  </a>
                </li>
                {email && (
                  <li className="flex items-start gap-2">
                    <i className="ri-mail-line mt-0.5" aria-hidden="true"></i>
                    <a href={`mailto:${email}`} className="hover:underline break-all">
                      {email}
                    </a>
                  </li>
                )}
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-0.5" aria-hidden="true"></i>
                  <span>{addr}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-950/20 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs opacity-80">
          <span>
            © {new Date().getFullYear()}{" "}
            {data?.club_name || "대전민들레로타리클럽"}. All rights reserved.
          </span>
          <span>
            {(data?.district || "국제로타리 3680지구")} · Rotary Club of Daejeon Mindeulle
          </span>
        </div>
      </div>
    </footer>
  );
}